<template>
  <div v-if="text" :class="attributes">
    <p class="text-sm text-white" v-html="text"></p>
  </div>
</template>

<script>
export default {
  name: 'Message',
  props: {
    message: Object
  },
  computed: {
    attributes: function () {
      let attributes = 'flex w-full p-3 mb-5 rounded'

      if (!this.message) return attributes

      if (this.message.status == 400) {
        attributes += ' bg-red-300'
      } else {
        attributes += ' bg-yellow-300'
      }

      return attributes
    },
    text: function () {
      let text = this.message ? this.message.text : null

      if (text instanceof Object) {
        let newText = ''

        for (var msg of text) {
          newText += `${msg.msg || ''}<br/>`
        }

        text = newText
      }

      return text
    }
  }
}
</script>
